import React, { useState, useEffect, useContext } from 'react';
import { userContext } from '../../UserContext';

function GenerateReportButton() {
    const [buttonGenerateClicked, clickGenerateButton] = useState(false);
    const [buttonGenerateAllClicked, clickGenerateAllButton] = useState(false);
    const [driverRankInputVal, driverRankInput] = useState('');
    const [driverName, setDriverName] = useState('')
    const [driverNric, setDriverNric] = useState('')
    const [driverNode, setDriverNode] = useState('')
    const [driverArray, setDriverNameArray] = useState(["Please select a TO"]);
    const [loading, setLoading] = useState(true)
    const userInfo = useContext(userContext);
    const driverRankArray = ["REC", "PTE", "LCP", "CPL", "CFC", "3SG", "2SG", "1SG", "SSG", "MSG"]
    const handleDriverRankInputChange = (event) => {
        driverRankInput(event.target.value);
    };
    
    const driverRank = driverRankInputVal.toUpperCase()
    
    const handleNameSelectChange = (event) => {
        let driverDetailsRaw = event.target.value
        const driverDetails = driverDetailsRaw.split(";")
        setDriverName(driverDetails[0].slice(0, -1))
        setDriverNric(driverDetails[1].slice(1, -1))
        setDriverNode(driverDetails[2].slice(1))
    }

    const getDriverFromNode = () => {
        const driverNames = []
        setLoading(true)
        fetch("https://mv.cylee.xyz/getDrivers", {
            method: "GET"
        }).then(response => {
            if (!response.ok) {
                alert("Error getting drivers")
            } else {
                response.json().then(result => {
                    for (let i = 0; i < result.length; i++) {
                        const driverInfo = result[i];
                        if (userInfo.userInfo.node.toUpperCase() == "HQ" || userInfo.userInfo.node.toUpperCase() == "ADMIN") {
                            driverNames.push(driverInfo)
                        } else if (driverInfo.DriverNode == userInfo.userInfo.node.toUpperCase()) {
                            driverNames.push(driverInfo)
                        }
                    }
                    console.log(driverNames)
                    setDriverNameArray(driverNames)
                    setLoading(false)
                })
            }
        })
        
        return driverNames
    }

    useEffect(() => {
        getDriverFromNode()
    }, [])


    useEffect(() => {
        setLoading(true)
        if (buttonGenerateClicked) {
            fetch("https://mv.cylee.xyz/generateDriverReport", {
                method: "POST",
                body: JSON.stringify({
                    "driverName": driverName,
                    "driverRank": driverRank,
                    "driverNric": driverNric,
                    "driverNode": driverNode
                })
            }).then(response => {
                if (!response.ok) {
                    response.text().then(result => {
                        alert("Error!! " + result)
                    })
                } else {
                    const fileName = response.headers.get("content-disposition").replace("attachment; filename=", "")
                    response.blob().then(blob => {
                        const url = window.URL.createObjectURL(blob)
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute(
                          'download',
                          fileName,
                        );
                        link.click()
                    }).catch(error => {
                        alert(error)
                    })
                }
            }).catch(error => {
                alert(error)
            }).finally(() => {
                setLoading(false)
            })
            clickGenerateButton(false)
        }

        if (buttonGenerateAllClicked) {
            fetch("https://mv.cylee.xyz/generateAllReports", {
                method: "POST",
                body: JSON.stringify({
                    "driverName": '',
                    "driverRank": '',
                    "driverNric": '',
                    "driverNode": userInfo.userInfo.node.toUpperCase()
                })
            }).then(response => {
                if (!response.ok) {
                    response.text().then(result => {
                        alert("Error!! " + result)
                    })
                } else {
                    const fileName = response.headers.get("content-disposition").replace("attachment; filename=", "")
                    response.blob().then(blob => {
                        const url = window.URL.createObjectURL(blob)
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute(
                          'download',
                          fileName,
                        );
                        link.click()
                    }).catch(error => {
                        alert(error)
                    })
                }
            }).catch(error => {
                alert(error)
            }).finally(() => {
                setLoading(false)
            })
            clickGenerateAllButton(false)
        }
    }, [buttonGenerateClicked, buttonGenerateAllClicked])

    const GenerateReport = () => {
        clickGenerateButton(true)
    }

    const GenerateAllReports = () => {
        clickGenerateAllButton(true)
    }

    if (!loading) {
        return (
            <section className="GenerateReport">
                <select name='DriverName' onChange={handleNameSelectChange}>
                    <option>-Select a TO-</option>
                    {driverArray.map(driver => {
                        return(
                            <option key={driver.Id} value={[driver.DriverName, ";" ,driver.DriverNric, ";", driver.DriverNode]}>{driver.DriverName}</option>
                        )
                    })}
                </select>
                <br />
                <select name='DriverRank' onChange={handleDriverRankInputChange}>
                    <option>-Select a Rank-</option>
                    {driverRankArray.map(rank => {
                        return(
                            <option key={rank} value={rank}>{rank}</option>
                        )
                    })}
                </select>
                <br />
                <a download={GenerateReport} target='_blank'>
                    <button onClick={GenerateReport}>
                        Generate
                    </button> 
                </a>
                <a download={GenerateAllReports} target='_blank'>
                    <button onClick={GenerateAllReports}>
                        Generate all reports
                    </button>
                </a>
            </section>
        )
    } else {
        return (
            <section className="GenerateReport">
                <p>Loading...</p>
            </section>
        )
    }
}

export default GenerateReportButton